import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Select, message } from 'antd';

import history from '../../config/history';
import {
  createQueryString,
  parseQueryParams,
} from '../../utils/queryStringUtils';
import { forwardTo } from '../../utils/browserHistoryUtils';

import {
  querySupplierCaps,
  getSupplierSearchMenu,
  getContractCenterData,
  addParticipants,
  // createRFQ,
} from './graphql';
import createRFQ from '../../graphql/sendRFQ';
import './SupplierCapabilties.scss';
import { supplierCapabilitiesRoute } from '../../config/navigation/routes';


const { Option } = Select;

export default function SupplierCapabilitiesHOC(SupplierCapabiltiesPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      location: PropTypes.object.isRequired,
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        jwtToken: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        email: PropTypes.string,
        cageCode: PropTypes.string,
        permissions: PropTypes.number,
      }).isRequired,
    };
    state = {
      loading: false,
      supplierList: [],
      supplierAggs: {},
      supplierHits: null,
      selectedSuppliers: [],
      selectAll: 0,
      rawSelected: {},
      modalOpen: false,
      modalVisible: false,
      newRfq: null,
      selectedRfq: null,
      options: [],
      supplierSelections: {}, // these are the search criteria the user has selected. value: key
      supplierSearchCriteria: {}, // these are the search criteria the user has selected. key: value
      supplierSearchMenuSwitch: [], // these are the true-false search criteria available for the user.
      supplierSearchMenuSelect: {}, // these are the single and multi select search criteria and possible values available for the user.
    };
    async componentDidMount() {
      this.initializeSupplierSearchCriteriaAndMenu();
      this.searchFromQueryString();
      await this.getContractData(this.props.auth.organizationId);
    }

    async componentDidUpdate(prevProps) {
      if (prevProps.location.search !== this.props.location.search) {
        await this.searchFromQueryString();
      }
    }

    initializeSupplierSearchCriteriaAndMenu = async () => {
      const data = await getSupplierSearchMenu();
      const { menu, menuCamelCase } = data.getSupplierSearchMenu;
      const supplierSearchCriteria = {};
      const supplierSearchMenuSwitch = [];
      const supplierSearchMenuSelect = {};

      Object.keys(menu).forEach(
        key => {
          if (Array.isArray(menu[key]) && menu[key].length === 2 && (menu[key][0] === "true" || menu[key][1] === "true")) {
            supplierSearchCriteria[menuCamelCase[key]] = null;
            supplierSearchMenuSwitch.push(key)
          }
          else if (key === "Weight Range") {
            supplierSearchCriteria[menuCamelCase[key]] = null;
            supplierSearchMenuSelect[key] = menu[key]
          }
          else if (Array.isArray(menu[key])) {
            supplierSearchCriteria[menuCamelCase[key]] = [];
            supplierSearchMenuSelect[key] = menu[key]
          }
          else {
            supplierSearchCriteria[menuCamelCase[key]] = {};
            supplierSearchMenuSelect[key] = menu[key]
          }
        }
      );
      this.setState({
        supplierSearchMenuSwitch,
        supplierSearchMenuSelect,
        supplierSearchMenuCamelCase: menuCamelCase
      });
    }

    pick = (obj, keys) =>
      keys
        .map(k => (k in obj ? { [k]: obj[k] } : {}))
        .reduce((res, o) => Object.assign(res, o), {});


    // This is called when user changes something in side men u OR when he removes a criterium form the Search Criteria box.
    onChange = async (checkedValues, type) => {
      if (checkedValues === false) {
        checkedValues = null;
      }
      if (checkedValues === true) {
        checkedValues = 'true';
      }

      const queryparams = this.state.supplierSearchCriteria;
      queryparams[type] = checkedValues;
      Object.keys(queryparams).forEach(
        // eslint-disable-next-line eqeqeq
        key => queryparams[key] == null && delete queryparams[key]
      );
      this.putQueryStringInUrl(queryparams);
    };

    convert = ({ data = null, columnDelimiter = ',', lineDelimiter = '\n' }) => {
      let result;
      let ctr;

      if (data === null || !data.length) {
        return null;
      }

      const keys = Object.keys(data[0]);
      result = '';
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      data.forEach(item => {
        ctr = 0;
        keys.forEach(key => {
          if (ctr > 0) {
            result += columnDelimiter;
          }

          result +=
            typeof item[key] === 'string' && item[key].includes(columnDelimiter)
              ? `"${item[key]}"`
              : item[key];
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
    };

    searchFromQueryString = async () => {
      this.setState({ loading: true });

      const location = this.props.location;
      const queryParams = parseQueryParams(location);
      const supplierInfo = await querySupplierCaps(queryParams);

      const array = {};

      Object.keys(queryParams).forEach(
        // eslint-disable-next-line eqeqeq
        key => {
          const value = queryParams[key];
          if (value && Array.isArray(value)) {
            value.forEach(element => {
              if (element) {
                array[element] = key;
              }
            });
          } else if (value) {
            array[value] = key
          }

          return queryParams[key] == null && delete queryParams[key];
        },
      );

      if (supplierInfo.supplierSearch && supplierInfo.supplierSearch.suppliers) {
        this.setState({
          loading: false,

          supplierList: supplierInfo.supplierSearch.suppliers,
          supplierAggs: supplierInfo.supplierSearch.supplierAggs,
          supplierHits: supplierInfo.supplierSearch.suppliers.length,
          supplierSelections: array,
          supplierSearchCriteria: queryParams,
        });
      } else {
        this.setState({
          supplierList: [],
          loading: false,
        });
      }
    };

    putQueryStringInUrl = queryParams => {
      const url = `${supplierCapabilitiesRoute}?${createQueryString(queryParams)}`;
      forwardTo(url);
    };

    // This is called when user removes criterium from Search Criteria box.
    deselect = e => {
      const key = this.state.supplierSelections[e];
      let value = this.state.supplierSearchCriteria[key];
      if (Array.isArray(value)) {
        const index = value.indexOf(e);
        if (index > -1) {
          value.splice(index, 1);
        }
      } else {
        value = null;
      }

      this.onChange(value, key);
    };

    getSelectedSuppliers = supplierArr => {
      const newArr = [...supplierArr].map(cage => cage.trim());

      this.setState({
        selectedSuppliers: newArr,
      });
    };

    downloadCsv = () => {
      /* eslint-disable */
      const res = this.convert({ data: this.state.supplierList });
      const pom = document.createElement('a');
      const csvContent = res; //here we load our csv data
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      pom.href = url;
      pom.setAttribute('download', 'suppliers.csv');
      pom.click();
      /* eslint-enable */
    };

    openModal = async () => {
      if (this.props.auth.permissions && this.props.auth.permissions.includes(1)) {
        if (!this.state.selectedSuppliers[0]) {
          message.warn({
            content: 'Please use \'ICON Members Only\' from left side menu and Select Supplier(s) to Send an RFQ',
            style: {
              marginTop: '10vh',
            },
          }, 6);
        } else {
          this.setState({
            modalOpen: true,
          });
        }
      } else {
        if (this.props.auth.cageCode.startsWith('OG')) {
          message.warn({
            content: 'Currently you do not have permissions to use Send RFQ but you can enable it by updating you user profile and relogin.',
            style: {
              marginTop: '10vh',
            },
          }, 6);
        } else if (!this.props.auth.cageCode.startsWith('OG') && this.props.auth.cageCode.startsWith('O')) {
          this.setState({
            modalVisible: true,
          });
        } else {
          message.warn({
            content: 'Your account does not have permission to submit RFQs, your organization administrator can enable this permission in your user profile.',
            style: {
              marginTop: '10vh',
            },
          }, 6);
        }
      }
    };

    closeModal = () => {
      this.setState({ modalOpen: false });
    };

    onRadioChange = checked => {
      this.setState({
        newRfq: checked,
        selectedRfq: null,
      });
    };

    onSelectChange = value => {
      this.setState({
        selectedRfq: value,
        newRfq: false,
      });
      console.log(this.state.newRfq);
    };

    changeSelectAllValue = (rawSelected, value) => {
      this.setState({
        rawSelected,
        selectAll: value,
      });
    };

    clearAll = async () => {
      this.setState({
        supplierSelections: {},
        supplierSearchCriteria: {},
      });
      history.push(supplierCapabilitiesRoute);
    };

    handleOkRfq = async () => {
      let rfq = this.state.selectedRfq;
      let res = null;
      if (this.state.selectedRfq) {
        res = await addParticipants(
          this.props.auth.id,
          this.state.selectedRfq,
          this.state.selectedSuppliers,
        );
      } else {
        const rfqInput = {
          participants: this.state.selectedSuppliers
        }
        res = await createRFQ(this.props.auth.id, rfqInput);
        rfq = res.rfqId;
      }
      const { status } = res;
      if (status !== 'success') {
        // TODO: error Handling
      }
      history.push(`contractcenter/rfq?rfq=${rfq}`);
    };

    getContractData = async organizationId => {
      const data = await getContractCenterData(organizationId);
      // add error handling

      const combinedArr = [...data.rfq.drafts, ...data.rfq.submitted];
      const options = [];
      combinedArr.forEach(element => {
        options.push(
          <Option value={element.rfqId}>{element.description}</Option>,
        );
      });

      this.setState({
        options,
      });
    };

    closeGModal = () => {
      this.setState({ modalVisible: false });
    };

    render() {
      const {
        supplierSelections,
        supplierSearchCriteria,
        supplierSearchMenuSwitch,
        supplierSearchMenuSelect,
        supplierSearchMenuCamelCase,
        supplierAggs,
        supplierHits,
        loading,
        supplierList,
        options,
        rawSelected,
        modalOpen,
        modalVisible,
        newRfq,
        selectedRfq,
        selectAll,
      } = this.state;
      const { auth } = this.props;
      const pageProps = {
        auth,
        supplierSelections,
        supplierSearchCriteria,
        supplierSearchMenuSwitch,
        supplierSearchMenuSelect,
        supplierSearchMenuCamelCase,
        options,
        onChange: this.onChange,
        supplierAggs,
        supplierHits,
        deselect: this.deselect,
        clearAll: this.clearAll,
        downloadCsv: this.downloadCsv,
        openModal: this.openModal,
        loading,
        supplierList,
        getSelectedSuppliers: this.getSelectedSuppliers,
        selectAll,
        changeSelectAllValue: this.changeSelectAllValue,
        rawSelected,
        modalOpen,
        handleOkRfq: this.handleOkRfq,
        closeModal: this.closeModal,
        newRfq,
        selectedRfq,
        onRadioChange: this.onRadioChange,
        onSelectChange: this.onSelectChange,
        modalVisible,
        closeGModal: this.closeGModal,

      };
      return <SupplierCapabiltiesPage {...pageProps} />;
    }
  }
  return withRouter(WrappedComponent);
}


// WEBPACK FOOTER //
// ./src/pages/SupplierCapabilities/SupplierCapabilitiesHOC.jsx